import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "./actionTypes";
import * as StoreTypes from "../DataTypes/storeTypes";
import * as Actions from "./actions";
import * as RequestTypes from "../DataTypes/requestTypes";
import * as Fetch from "../../Common/fetch";
import * as LocationTypes from "../DataTypes/locationTypes";
import * as Notifications from "../../Common/Notifications/helper";
import { Step } from "../DataTypes/storeTypes";

export function getLocations(dispatch, state: StoreTypes.IStore) {
    const request: RequestTypes.IAppointmentRequestBase = {
        type: StoreTypes.BookingType[state.initialSettings.type],
    };

    return Fetch.post<LocationTypes.ILocation[]>(state.initialSettings.getLocationsUrl, request)
        .then((data) => dispatch(updateLocations(data)))
        .catch((data) => Notifications.error(data.message));
}

function updateLocations(
    locations: LocationTypes.ILocation[]
): ActionGenerics.IParamAction<ActionTypes.Actions, LocationTypes.ILocation[]> {
    return { type: ActionTypes.Actions.UpdateLocations, parameter: locations };
}

function selectLocationInternal(id: number): ActionGenerics.IParamAction<ActionTypes.Actions, number> {
    return { type: ActionTypes.Actions.SelectLocation, parameter: id };
}

export function selectLocation(id: number) {
    return (dispatch, getState: () => StoreTypes.IStore) => {
        dispatch(selectLocationInternal(id));
        dispatch(Actions.flushSteps([Step.Service, Step.Provider, Step.When, Step.Group]));

        dispatch(Actions.moveNext());
    };
}
